<template>
  <h1>内容审核策略上传</h1>
  <div class="mb-20 text-right">
    <el-button type="primary" @click="uploadHandler">上传新策略</el-button>
  </div>
  <el-table
    class="strategy-list mb-20"
    :data="tableData"
    border
    style="width: 100%"
  >
    <el-table-column sortable prop="filename" label="策略名称" min-width="600">
      <template #default="{ row }">
        <el-button
          link
          type="primary"
          @click="previewFile(row.file_hash, row.file_type)"
        >
          {{ row.filename }}
        </el-button>
      </template>
    </el-table-column>
    <el-table-column
      sortable
      prop="upload_user"
      label="上传人员"
      min-width="400"
    />
    <el-table-column prop="" label="操作" min-width="200">
      <template #default="{ row }">
        <el-button type="primary" text @click="removeData(row)">
          删除
        </el-button>
      </template>
    </el-table-column>
  </el-table>
  <!-- <div class="page-block flex justify-end">
    <el-pagination
      v-model:current-page="page"
      v-model:page-size="pageSize"
      :page-sizes="[20, 50, 100, 200]"
      layout="prev, pager, next,sizes, total"
      :total="total"
      background
    />
  </div> -->

  <el-dialog
    v-model="uploadVisible"
    title="上传新策略"
    width="800"
    @close="close"
  >
    <el-upload
      drag
      action="#"
      :show-file-list="false"
      :auto-upload="true"
      :http-request="customUpload"
      :before-upload="beforeUpload"
      accept=".JPG,.JPEG,.PNG,.BMP,.GIF,.mov,.mp4"
    >
      <el-icon class="el-icon--upload"><upload-filled /></el-icon>
      <div class="el-upload__text">将文件拖拽到此处 或 <em>点击上传</em></div>
      <template #tip>
        <div class="el-upload__tip">
          支持 JPG、JPEG、PNG、BMP、GIF、MP4、MOV 格式
        </div>
        <div class="mt-20 flex items-center" v-for="item in fileList">
          <div class="mr-20 flex items-center">
            <div class="mr-20 flex items-center">
              <span class="mr-20"> {{ item.name }}</span>
              <span v-if="item?.raw?.lastModified">{{
                dayjs(item.raw.lastModified).format("YYYY/MM/DD")
              }}</span>
            </div>
            <el-icon><CloseBold /></el-icon>
          </div>
          <el-button
            style="margin-left: 40px"
            type="success"
            round
            @click="saveHandler"
            >保存</el-button
          >
        </div>
      </template>
    </el-upload>
    <template #footer>
      <div class="dialog-footer"></div>
    </template>
  </el-dialog>
  <!-- 预览对话框 -->
  <el-dialog
    v-model="previewDialogVisible"
    title="文件预览"
    width="70%"
    :before-close="handleClose"
  >
    <video
      v-if="previewUrl && isVideo"
      :src="previewUrl"
      controls
      style="width: 100%"
    ></video>
    <img v-if="previewUrl && !isVideo" :src="previewUrl" style="width: 100%" />
  </el-dialog>
</template>

<script lang="ts" setup>
import dayjs from "dayjs";
import { onMounted, ref } from "vue";
import {
  uploadStrategyApi,
  getStrategyListApi,
  deleteStrategyByHashApi,
  strategyFilePreview,
} from "@/api/index.ts";
import {
  ElForm,
  ElMessage,
  ElMessageBox,
  UploadUserFile,
  ElLoading,
} from "element-plus";

const previewDialogVisible = ref(false);
const previewUrl = ref("");
const isVideo = ref(false);

const tableData = ref([]);
const total = ref(100);
const pageSize = ref(20);
const page = ref(1);
const removeData = (row) => {
  ElMessageBox.confirm("确认删除策略？", "提示", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning",
  }).then(async () => {
    const res = await deleteStrategyByHashApi(row.file_hash);
    if (res.code === "success") getStrategyList();
  });
};
const fileList = ref<File[]>([]);
const uploadVisible = ref(false);
const uploadHandler = () => {
  uploadVisible.value = true;
};
const saveHandler = () => {
  getStrategyList();
  close();
};
const close = () => {
  uploadVisible.value = false;
  fileList.value = [];
};
const beforeUpload = (file: File) => {
  // const limitSize = 3 * 1024 * 1024;
  // if (file.size > limitSize) {
  //   ElMessage({
  //     message: "上传文件大小不能超过 3MB",
  //     type: "error",
  //   });
  //   return false;
  // }
  return true;
};
const customUpload = async (file) => {
  const res = await uploadStrategyApi(file.file);
  ElMessage({
    message: res.message,
    type: res.code,
    center: true,
  });
  if (res.code === "success") {
    fileList.value.push(file.file);
  }
  //   fileList.value.push(file);
};

const getStrategyList = async () => {
  const res = await getStrategyListApi();
  if (res.code === "success") {
    tableData.value = res.content;
  }
};

// 添加预览方法
const previewFile = async (filename: string, fileType: string) => {
  const loading = ElLoading.service({
    lock: true,
    text: "文件加载中，请稍后",
    background: "rgba(0, 0, 0, 0.7)",
  });

  try {
    const res = await strategyFilePreview(`${filename}.${fileType}`);
    if (res?.code === "error") throw new Error(res?.message);
    if (!res.content) throw new Error("预览的文件内容为空或不可用");
    previewUrl.value = URL.createObjectURL(res.content as Blob);
    const videoEnd = ["mp3", "mp4", "mov"];
    isVideo.value = videoEnd.some((item) => filename.endsWith(item));
    loading.close();
    previewDialogVisible.value = true;
  } catch (error) {
    loading.close();
    console.error("预览失败", error);
    ElMessage.error(error?.message || "该文件未生成水印文件");
  }
};
const handleClose = () => {
  if (previewUrl.value) {
    URL.revokeObjectURL(previewUrl.value);
    previewUrl.value = "";
  }
  previewDialogVisible.value = false;
};

onMounted(() => {
  getStrategyList();
});
</script>

<style lang="scss" scoped>
.text-right {
  text-align: right;
}
.mb-20 {
  margin-bottom: 20px;
}
.mt-20 {
  margin-top: 20px;
}
.mr-20 {
  margin-right: 20px;
}

.justify-end {
  justify-content: end;
}
.flex {
  display: flex;
}
.items-center {
  align-items: center;
}
.justify-between {
  justify-content: space-between;
}
.flex-1 {
  flex: 1;
}
.strategy-list {
  height: calc(100% - 140px);
}
.page-block {
  z-index: 9;
  background-color: #fff;
  width: calc(100% - 312px);
  box-shadow: 0 -5px 10px -5px rgba(0, 0, 0, 0.1),
    0 5px 10px -5px rgba(0, 0, 0, 0.1);
  padding: 10px;
  position: fixed;
  bottom: 0;
  right: 26px;
}
</style>
